import Keycloak from 'keycloak-js';
import { config } from "./config/environment"

// Initialize Keycloak with environment-based configuration
const keycloak = new Keycloak({
    url: config.KEYCLOAK_URL,
    realm: config.KEYCLOAK_REALM,
    clientId: config.KEYCLOAK_CLIENT_ID,
})

// Debug logging for development
if (process.env.NODE_ENV !== "production") {
    console.log("Keycloak Config:", {
        url: config.KEYCLOAK_URL,
        realm: config.KEYCLOAK_REALM,
        clientId: config.KEYCLOAK_CLIENT_ID,
    })
}

export default keycloak;

